import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/clients/$clientName/")({
	loader: ({ params }) => {
		const { clientName } = params
		return redirect({ to: `/clients/$clientName/fleet-overview`, params: { clientName } })
	},
})
